import React, { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import { getImidServiceUrl } from "utils/api-util";

const CriticalPointTable = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const token = window.localStorage.getItem("token");
  const baseUrl = getImidServiceUrl();

  const url = `${baseUrl}/critical-period`;
  //   const url = "https://jsonplaceholder.typicode.com/users";

  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };
  const formattedDateTime = (isoString) => {
    const dateObj = new Date(isoString);
    return dateObj.toLocaleString("en-US", options);
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);
      setError("");
      const headers = {
        // Add any headers you need here
        "Content-Type": "application/json",
        // Example header:
        Authorization: `Bearer ${token}`,
      };
      const response = await fetch(url, { headers });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setData(data);
      console.log(data);
    } catch (error) {
      setError("");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  let content = null;

  if (data.length > 0) {
    content = data.map((item, index) => {
      return (
        <tr key={item.id} className="h-12">
          <td className=" w-[5%] text-sm text-center ">{index + 1}</td>

          <td className=" w-[30%] text-center text-sm">
            {formattedDateTime(item?.startTime)}
          </td>
          <td className=" w-[30%] text-center text-sm">
            {formattedDateTime(item?.endTime)}
          </td>
          <td className={`w-[30%] text-center text-sm`}>{item?.tariff}</td>
        </tr>
      );
    });
  } else if (isLoading && error) {
    content = <p>Something went wrong</p>;
  }

  return (
    <div className="  h-fit w-full">
      <table className=" w-full   my-6">
        <thead>
          <tr>
            <th className="text-[13px] bg-[#0074bb] w-[5%] text-white text-center  ">
              S/N
            </th>
            <th className="text-[13px] bg-[#0074bb] text-center text-white w-[30%]  ">
              Start Time
            </th>
            <th className="text-[13px] bg-[#0074bb] text-center text-white w-[30%]  ">
              End Time
            </th>
            <th className="text-[13px] bg-[#0074bb] text-center text-white w-[30%]  ">
              Tariff
            </th>
          </tr>
        </thead>
        <tbody>{content}</tbody>
      </table>

      {data.length === 0 && !isLoading && (
        <div className=" flex justify-center items-center w-full h-[50px]">
          <p className="w-[50%] font-bold text-[#BDBDBD] text-center">
            No critical period active
          </p>
        </div>
      )}

      {isLoading && (
        <div className="w-full items-center flex justify-center">
          <ClipLoader color="#008be0" size={20} />
        </div>
      )}
      {error && <p className="text-red-500 text-[12px] mb-3">{error}</p>}
    </div>
  );
};

export default CriticalPointTable;
